export const handleRole = (role, route, { is_staff, is_superuser } = {}) => {
    // Django staff/superusers run the admin dashboard regardless of their
    // foundation role, so check these flags before the role.
    if (is_staff || is_superuser) {
      return route('/dashboard');
    }
    if (role?.toLowerCase() === 'staff') {
      return route('/familylisting');
    }
    if (role?.toLowerCase() === 'admin') {
      return route('/dashboard');
    }
    if (role?.toLowerCase() === 'medicalstaff' || role?.toLowerCase() === 'pharmacist') {
      return route('/dashboard/verify_fingerprint');
    }
    return route('/login');
  };

  export const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

 export function formatDate(isoString) {
    const date = new Date(isoString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
  
    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
    }
  
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    }
  
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    }
  
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
    }
  
    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) {
      return `${diffInWeeks} week${diffInWeeks !== 1 ? "s" : ""} ago`;
    }
  
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} month${diffInMonths !== 1 ? "s" : ""} ago`;
    }
  
    // For anything >= 1 year, return formatted date
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  
  
  